import UnityTypeRepository from '@/shared/http/repositories/realestate/unitytype'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise.js'
import { toast, loading } from '@/shared/utils/UIHelper'

const tabIndex = {
  typeende: 0,
  midi: 1
}

export default {
  name: 'UnityTypeSelector',
  components: { },
  props: ['data', 'emprendimentoId'],

  data () {
    return {
      obj: '',
      nameInput: '',
      imgDetails: '',
      dataFiles: '',
      dataFilesTabPrec: null,
      // dataFilesTabPrec: {
      //   id: '',
      //   arquivo: {
      //     extensao: ''
      //   }
      // },
      imgString: '',
      tipoId: '',
      tabIndex: tabIndex.typeende
    }
  },

  mounted () {
  },

  methods: {
    onDragLeave (event) {
      event.target.style.opacity = '1'
      event.preventDefault()
      event.stopPropagation()

      this.isDragging = false
    },
    imageDetails (obj) {
      this.imgDetails = obj
      this.$refs.UnityTypeImages.show()
    },
    removeArquivo (e) {
      UnityTypeRepository.RemoveImage(this.tipoId)
        .then(res => {
          this.getArquivo(this.tipoId)
          if (res.status === 200) {
            toast.success(`Planta removida com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao remover a planta`)
          loading.pop()
        })
    },
    removeArquivoTabPrec (e) {
      UnityTypeRepository.RemoveImage(this.tipoId)
        .then(res => {
          this.getArquivoTabPrec(this.tipoId)
          if (res.status === 200) {
            toast.success(`Tabela de preço removida com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao remover a planta`)
          loading.pop()
        })
    },
    SendImage (e) {
    },
    sendArquivo (e) {
      let img = new FormData()
      loading.push()
      let fileArray = null
      if (e.target.files === undefined) {
        fileArray = e.dataTransfer.files
      } else {
        fileArray = e.target.files
      }
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        img.append('imgs', fileArray[fileCounter])
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      UnityTypeRepository.SaveArquivo(this.tipoId, this.data.id, img, conf)
        .then(Response => {
          this.getArquivo(this.tipoId)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    sendArquivoTabPrec (e) {
      let img = new FormData()
      loading.push()
      let fileArray = null
      if (e.target.files === undefined) {
        fileArray = e.dataTransfer.files
      } else {
        fileArray = e.target.files
      }
      for (var fileCounter = 0; fileCounter < (fileArray).length; fileCounter++) {
        img.append('imgs', fileArray[fileCounter])
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      UnityTypeRepository.SaveArquivoTabPrec(this.tipoId, this.data.id, img, conf)
        .then(Response => {
          this.getArquivoTabPrec(this.tipoId)
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    GetValueFile (e) {
      this.nameInput = e.target.files[0].name
    },
    onDragEnter (event) {
      event.target.style.opacity = '0.7'
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (this.hasFolderPermission(this.folderPermission.WRITE, this.folder)) {
        if (this.folder && !this.isUndeleting && !this.editingFile && !this.showHistory) {
          event.dataTransfer.dropEffect = 'copy'
          event.dataTransfer.effectAllowed = 'copy'
          this.isDragging = true
        }
      }
    },
    removeFile (id) {
      loading.push()
      FileEnterpriseRepository.Delete(id)
        .then(Response => {
          loading.pop()
          this.getArquivo(this.tipoId)
          this.getArquivoTabPrec(this.dataFilesTabPrec.id, this.tipoId)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    addImg (e) {
      document.querySelector('.inputHidden').click()
    },
    addImgTabPrec (e) {
      document.querySelector('.tabprec').click()
    },
    getArquivo (id) {
      loading.push()
      UnityTypeRepository.GetArquivo(id)
        .then(Response => {
          this.dataFiles = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getArquivoTabPrec (id) {
      loading.push()
      UnityTypeRepository.GetArquivoTabPrec(this.data.id, this.tipoId)
        .then(Response => {
          if (Response.data !== '') {
            this.dataFilesTabPrec = Response.data
          } else {
            this.dataFilesTabPrec = null
          }
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          console.log(Error)
        })
    },
    onDragOver (event) {
      event.preventDefault()
      event.stopPropagation()
      event.dataTransfer.dropEffect = 'none'
      event.dataTransfer.effectAllowed = 'none'

      if (!this.isUndeleting) {
        event.dataTransfer.dropEffect = 'copy'
        event.dataTransfer.effectAllowed = 'copy'
      }
    },
    show (id) {
      this.getArquivo(id)
      this.getArquivoTabPrec(id)
      this.$refs.UnityTypeImages.show()
    },
    cancelImage () {
      this.$refs.UnityTypeImages.hide()
      document.querySelector('.inputHidden').value = ''
      this.nameInput = ''
    },

    teste (e) {
      // Get the modal
      this.$refs.UnityTypeImages.hide()
      var modal = document.getElementById('myModal')

      // Get the image and insert it inside the modal - use its "alt" text as a caption
      var img = e.target
      var modalImg = document.getElementById('img01')
      var captionText = document.getElementById('caption')
      modal.style.display = 'block'
      modalImg.src = img.src
      captionText.innerHTML = img.alt
      // Get the <span> element that closes the modal
      var span = document.querySelector('.close')

      // When the user clicks on <span> (x), close the modal
      span.onclick = function () {
        modal.style.display = 'none'
      }
    },
    openPopup () {
      this.$refs.teste.show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/UnityTypeSelector/UnityTypeSelector.js